<app-header></app-header>

<!-- preloader -->
<div [hidden]="isloader" class="preloader">
    <div class="preloader_block">
      <img src="assets/images/preloader.gif">
    </div>
</div>

<!-- Slider start -->
<div class="ak_page-header" [ngStyle]="{'background-image': 'url(' + banner + ')'}">
    <div class="container">
        <div class="box">
            <h2>{{title}}y</h2>
        </div>
    </div>
</div>
<!--/ Slider end -->

<section class="test-view-page">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12" [innerHtml]="description | sanatizeHtml"> </div>
        </div>
    </div>
</section>

<!-- <app-footer></app-footer> -->
